import { useEffect, useState } from "react";
import TextView from "./Typography";

const LoadingText = ({
		title = "Loading",
		color = "secondary",
		...props
	}) => {
	const [dots, setDots] = useState('');

	useEffect(() => {
		const interval = setInterval(() => {
			setDots(prevDots => {
				switch (prevDots) {
					case '':
						return '.';
					case '.':
						return '..';
					case '..':
						return '...';
					case '...':
					default:
						return '';
				}
			});
		}, 500);

		return () => clearInterval(interval);
	}, []);

	return (
		<TextView
			fontweight="medium"
			customclasses={`font-size-sm font-size-md color=${color}`}
		>
			{title}{dots}
		</TextView>
	);
};

export default LoadingText;